'use client';

import clsx from 'clsx';
import { useLocalityService } from '@/providers/Locality';
import Link from 'next/link';
import { GeneralInformation, Page } from '@/payload-types';

type linkFromGeneralInformation = NonNullable<
  NonNullable<GeneralInformation['socialNetworks']>[number]['social']
>[number]['link'];

export default function LocalityMoreInfoButton({
  callToAction,
  className,
}: {
  callToAction: any;
  className: string;
}) {
  const localityService = useLocalityService();
  const href =
    callToAction?.type === 'reference' &&
    typeof callToAction.reference?.value === 'object' &&
    callToAction.reference?.relationTo !== 'anchors' &&
    callToAction.reference.value.slug != null
      ? callToAction.reference.relationTo === 'pages'
        ? ((callToAction.reference.value as Page).breadcrumbs?.at(-1)?.url ??
          `/${callToAction.reference.value.slug}`)
        : `/${callToAction.reference.relationTo}/${callToAction.reference.value.slug}`
      : callToAction?.url;
  return (
    <div
      className={clsx(
        'flex items-center justify-center gap-x-6 xsmall:py-3 md:py-0',
        className,
      )}
    >
      {callToAction && href && (
        <Link
          href={`${localityService.addLocaliteToUrl(href)}`}
          className="rounded-md bg-[#0079AD] px-3.5 py-1 text-sm font-semibold text-white shadow-sm hover:bg-[#005E87] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 xsmall:text-center lg:text-left"
        >
          {callToAction.label}
        </Link>
      )}
    </div>
  );
}
